module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-5ed5f9bb.png";